export default __webpack_public_path__ + "static/media/ref-myslowickie-centrum-zdrowia.7db7f505.pdf";